import styled from '@emotion/styled';
import { FileReference } from '@kaizenplatform/belfast-entity';
import { IconButton } from '@material-ui/core';
import Edit from '@material-ui/icons/Edit';
import { createElement, FC, useState } from 'react';

import EditModificationRequestItem from '../../../../entity/EditModificationRequestItem';
import UploadingFile from '../../../../entity/UploadingFile';
import {
  DeliverableForCraetionDetailFragment,
  ModificationRequestItemForDetailFragment,
} from '../../../../generated/graphql';
import EditModificationRequestDialog from './EditModificationRequestDialog';

interface Props {
  deliverable: DeliverableForCraetionDetailFragment;
  modificationRequestItem: ModificationRequestItemForDetailFragment;
  editModificationRequestItem: EditModificationRequestItem;
  files: Array<FileReference>;
  bucketId?: string;
  index: number;
  onRemoveEditAssetFile: (fileId: string) => void;
  onOpenEditModificationRequestDialog: (index: number) => void;
  onCloseEditModificationRequestDialog: () => void;
  onSubmitEditModificationRequestDialog: (
    index: number,
    editModificationRequestItem: EditModificationRequestItem,
    modificationRequestItemId: string,
    duration: string,
    comment: string,
  ) => void;
  onRequestEditAssetFiles: (files: UploadingFile[], bucketId: string) => void;
  disabled?: boolean;
  className?: string;
}

const EditModificationRequestButton: FC<Props> = ({
  deliverable,
  modificationRequestItem,
  editModificationRequestItem,
  files,
  bucketId,
  index,
  onRemoveEditAssetFile,
  onOpenEditModificationRequestDialog,
  onCloseEditModificationRequestDialog,
  onSubmitEditModificationRequestDialog,
  onRequestEditAssetFiles,
  disabled,
  className,
}) => {
  const [isDialogOpen, setDialogOpen] = useState(false);
  return (
    <Root className={className}>
      <IconButton
        color="primary"
        onClick={() => {
          onOpenEditModificationRequestDialog(index);
          setDialogOpen(true);
        }}
        disabled={disabled}
      >
        <Edit />
      </IconButton>

      <EditModificationRequestDialog
        deliverable={deliverable}
        modificationRequestItem={modificationRequestItem}
        editModificationRequestItem={editModificationRequestItem}
        files={files}
        bucketId={bucketId}
        index={index}
        isOpen={isDialogOpen}
        onRequestClose={(_: any) => {
          setDialogOpen(false);
          onCloseEditModificationRequestDialog();
        }}
        onRequestEditAssetFiles={onRequestEditAssetFiles}
        onRemoveEditAssetFile={onRemoveEditAssetFile}
        onSubmit={(
          index: number,
          editModificationRequestItem: EditModificationRequestItem,
          modificationRequestItemId: string,
          duration: string,
          comment: string,
        ) => {
          onSubmitEditModificationRequestDialog(
            index,
            editModificationRequestItem,
            modificationRequestItemId,
            duration,
            comment,
          );
          setDialogOpen(false);
        }}
      />
    </Root>
  );
};

const Root = styled('div')({
  display: 'inline-block',
  lineHeight: 1,
});

export default EditModificationRequestButton;
